import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "fe-shared/src/components";
import { CalendarIcon } from "fe-shared/src/components/Icons";

import styles from "../OverrideRegYear.module.scss";

interface Props {
  onClickAction: () => void;
}

const OverrideRegYearButton = ({ onClickAction }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      id="override-reg-year-button"
      onClick={onClickAction}
      variant="inline"
      iconComponent={CalendarIcon}
      className={styles.overrideRegYearButton}
    >
      {t("transactions.details.regYear.overrideButton")}
    </Button>
  );
};

export default OverrideRegYearButton;
